import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, vShow as _vShow, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5b5991da"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "flex-center;"
};
const _hoisted_2 = {
  class: "flex-start",
  style: {
    "width": "100%",
    "font-weight": "bold"
  }
};
const _hoisted_3 = {
  key: 0,
  class: "bi bi-arrow-right"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bi bi-arrow-right"
}, null, -1));

const _hoisted_5 = {
  style: {
    "text-decoration": "underline"
  }
};
const _hoisted_6 = {
  key: 0,
  class: "flex-start",
  style: {
    "width": "100%"
  }
};
const _hoisted_7 = ["disabled"];
const _hoisted_8 = ["disabled"];
const _hoisted_9 = ["disabled"];
const _hoisted_10 = {
  style: {
    "width": "100%",
    "position": "sticky",
    "top": "1rem",
    "z-index": "900",
    "background-color": "#fff"
  }
};
const _hoisted_11 = {
  style: {
    "width": "100%",
    "height": "100%",
    "border": "1px solid #000",
    "display": "flex",
    "flex-wrap": "wrap"
  }
};
const _hoisted_12 = {
  style: {
    "width": "100%",
    "height": "5rem",
    "display": "flex",
    "flex-wrap": "wrap",
    "border-bottom": "1px solid #000"
  }
};
const _hoisted_13 = ["title"];
const _hoisted_14 = {
  style: {
    "width": "100%",
    "height": "50%"
  }
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = ["onClick", "title"];
const _hoisted_17 = {
  class: "flex-end",
  style: {
    "flex-wrap": "nowrap"
  }
};
const _hoisted_18 = ["title"];
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["disabled"];
const _hoisted_21 = ["disabled"];
const _hoisted_22 = ["disabled"];
const _hoisted_23 = ["disabled"];
const _hoisted_24 = ["disabled"];

const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "40%",
    "border-bottom": "1px solid #fff"
  }
}, null, -1));

const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#fff",
    "margin": "0 1rem"
  }
}, "▲", -1));

const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "40%",
    "border-bottom": "1px solid #fff"
  }
}, null, -1));

const _hoisted_28 = [_hoisted_25, _hoisted_26, _hoisted_27];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Modal = _resolveComponent("Modal");

  const _component_Ticket = _resolveComponent("Ticket");

  const _component_MultipleOption = _resolveComponent("MultipleOption");

  const _component_MultipleSelect = _resolveComponent("MultipleSelect");

  const _component_Tree = _resolveComponent("Tree");

  const _component_FloatMenu = _resolveComponent("FloatMenu");

  const _directive_focus = _resolveDirective("focus");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Modal, {
    show: $data.menuModal.show,
    "onUpdate:show": _cache[4] || (_cache[4] = $event => $data.menuModal.show = $event)
  }, {
    title: _withCtx(() => [_createTextVNode(_toDisplayString($data.menuModal.title), 1)]),
    body: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, _toDisplayString(_ctx._t('position')) + "：", 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.floatMenu.questionType.nav, (_nav, _navIndex) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, _toDisplayString(_nav.title), 1), _navIndex != $data.floatMenu.questionType.nav.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_3)) : _createCommentVNode("", true)], 64);
    }), 256)), $data.floatMenu.question ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString($data.floatMenu.question.title), 1)], 64)) : _createCommentVNode("", true)]), $data.menuModal.submit != $options.clickDeleteTypeSubmit && $data.menuModal.submit != $options.clickDeleteQuestionSubmit ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", null, _toDisplayString(_ctx._t('title')) + "：", 1), _createElementVNode("div", null, [_withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.menuModal.newTitle = $event),
      class: "input-self"
    }, null, 512), [[_directive_focus], [_vModelText, $data.menuModal.newTitle]])])])) : _createCommentVNode("", true)])]),
    footer: _withCtx(() => [$data.menuModal.submit == $options.clickUnsolvedSubmit ? (_openBlock(), _createElementBlock("button", {
      key: 0,
      class: "btn btn-self",
      style: {
        "color": "#0c0"
      },
      disabled: _ctx.user.is_readonly,
      onClick: _cache[1] || (_cache[1] = $event => $data.menuModal.submit())
    }, _toDisplayString(_ctx._t('submit')), 9, _hoisted_7)) : $data.menuModal.submit != $options.clickDeleteTypeSubmit && $data.menuModal.submit != $options.clickDeleteQuestionSubmit ? (_openBlock(), _createElementBlock("button", {
      key: 1,
      class: "btn btn-self",
      style: {
        "color": "#0c0"
      },
      disabled: _ctx.user.is_readonly,
      onClick: _cache[2] || (_cache[2] = $event => $data.menuModal.submit())
    }, _toDisplayString(_ctx._t('add')), 9, _hoisted_8)) : (_openBlock(), _createElementBlock("button", {
      key: 2,
      class: "btn btn-self",
      style: {
        "color": "#c00"
      },
      disabled: _ctx.user.is_readonly,
      onClick: _cache[3] || (_cache[3] = $event => $data.menuModal.submit())
    }, _toDisplayString(_ctx._t('delete')), 9, _hoisted_9))]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_Ticket, {
    show: $data.ticket.show,
    "onUpdate:show": _cache[5] || (_cache[5] = $event => $data.ticket.show = $event),
    questionType: $data.ticket.questionType
  }, null, 8, ["show", "questionType"]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
    style: _normalizeStyle([{
      'color': _ctx.questionRecordCount == 0 && _ctx.user.id && _ctx.userType == 'user' ? '#777' : '',
      'cursor': _ctx.questionRecordCount && _ctx.user.id == 0 && _ctx.userType == 'user' ? 'default' : 'pointer'
    }, {
      "width": "100%",
      "height": "50%",
      "font-size": "1.8rem",
      "border": "1px solid #000",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    }]),
    onClick: _cache[6] || (_cache[6] = $event => $options.clickToAfterSales())
  }, [_createTextVNode(_toDisplayString(_ctx._t("afterSalesQuestion")) + " ", 1), _ctx.questionRecordUnsolvedCount != 0 ? (_openBlock(), _createElementBlock("sup", {
    key: 0,
    class: "flex-center",
    style: {
      "position": "absolute",
      "right": "0",
      "padding": "5px",
      "font-size": "1rem",
      "color": "#fff",
      "min-width": "1rem",
      "height": "1.2rem",
      "border-radius": "5rem",
      "background-color": "#c00"
    },
    title: _ctx._t('unread') + '/' + _ctx._t('unresolved')
  }, _toDisplayString(_ctx.questionRecordUnreadCount) + "/" + _toDisplayString(_ctx.questionRecordUnsolvedCount), 9, _hoisted_13)) : _createCommentVNode("", true)], 4), _createElementVNode("div", _hoisted_14, [_createVNode(_component_MultipleSelect, {
    style: {
      "width": "100%",
      "height": "100%",
      "cursor": "pointer"
    },
    modelValue: _ctx.itemFilter,
    placeholder: _ctx._t('productFilter'),
    onChange: _cache[7] || (_cache[7] = $event => $options.changeItemFilter($event))
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getValidItem, _item => {
      return _openBlock(), _createBlock(_component_MultipleOption, {
        value: _item.id,
        class: "title-self",
        title: _item.name
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_item.name) + _toDisplayString(_item.description ? '(' + _item.description + ')' : ''), 1)]),
        _: 2
      }, 1032, ["value", "title"]);
    }), 256))]),
    _: 1
  }, 8, ["modelValue", "placeholder"])])]), _createVNode(_Transition, {
    name: "fold"
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", {
      style: _normalizeStyle([{
        "width": "100%",
        "overflow": "hidden auto"
      }, {
        'max-height': _ctx.isPC ? '62vh' : '50vh',
        'font-size': _ctx.isPC ? '' : '16px'
      }])
    }, [_createVNode(_component_Tree, {
      node: _ctx.catalog,
      nav: _ctx.nav,
      unfoldDegree: 2,
      elementId: _ctx.questionId,
      elementName: 'question',
      onClickNode: $options.clickNode,
      onClickElement: $options.clickElement,
      style: {
        "width": "100%",
        "height": "calc(100% - 3rem)",
        "padding": "10px"
      }
    }, {
      node: _withCtx(({
        nodeTarget
      }) => [_ctx.userType == 'admin' && nodeTarget.nav.length > 1 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "bi bi-gear tree-setting",
        style: {
          "cursor": "pointer"
        },
        onClick: $event => $options.clickTypeSetting($event, nodeTarget)
      }, null, 8, _hoisted_15)) : _createCommentVNode("", true), _ctx.userType == 'user' && nodeTarget.nav.length > 1 ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "bi bi-chat-dots tree-setting",
        style: {
          "cursor": "pointer"
        },
        onClick: $event => $options.clickTicket($event, nodeTarget),
        title: _ctx._t('needStaffService')
      }, null, 8, _hoisted_16)) : _createCommentVNode("", true)]),
      element: _withCtx(({
        nodeTarget,
        elementTarget
      }) => [_createElementVNode("div", _hoisted_17, [_ctx.userType == 'admin' ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: {
          "color": "#999",
          "font-size": "0.7rem",
          "line-height": "1.5rem",
          "max-width": "4rem",
          "white-space": "nowrap"
        },
        class: "bi bi-people",
        title: elementTarget.accessQuestion.length
      }, _toDisplayString(elementTarget.accessQuestion.length), 9, _hoisted_18)) : _createCommentVNode("", true), _ctx.userType == 'admin' ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        style: {
          "margin-left": "0.5rem"
        },
        class: "bi bi-gear tree-setting",
        onClick: $event => $options.clickElementSetting($event, nodeTarget, elementTarget)
      }, null, 8, _hoisted_19)) : _createCommentVNode("", true)])]),
      _: 1
    }, 8, ["node", "nav", "elementId", "onClickNode", "onClickElement"]), _ctx.userType == 'admin' ? (_openBlock(), _createBlock(_component_FloatMenu, {
      key: 0,
      show: $data.floatMenu.show,
      "onUpdate:show": _cache[15] || (_cache[15] = $event => $data.floatMenu.show = $event),
      x: $data.floatMenu.x,
      y: $data.floatMenu.y
    }, {
      default: _withCtx(() => [$data.floatMenu.question ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", {
        onClick: _cache[8] || (_cache[8] = $event => $options.clickCopyQuestionLink())
      }, _toDisplayString(_ctx._t('CopyQuestionLink')), 1), _createElementVNode("div", {
        disabled: _ctx.user.is_readonly,
        onClick: _cache[9] || (_cache[9] = $event => $options.clickDeleteQuestion()),
        style: {
          "color": "#c00"
        }
      }, _toDisplayString(_ctx._t('deleteQuestion')), 9, _hoisted_20)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [$data.floatMenu.questionType.nav.length > 2 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        disabled: _ctx.user.is_readonly,
        onClick: _cache[10] || (_cache[10] = $event => $options.clickAddType())
      }, _toDisplayString(_ctx._t('addType')), 9, _hoisted_21)) : _createCommentVNode("", true), $data.floatMenu.questionType.nav.length > 2 ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        disabled: _ctx.user.is_readonly,
        onClick: _cache[11] || (_cache[11] = $event => $options.clickChangeType())
      }, _toDisplayString(_ctx._t('changeType')), 9, _hoisted_22)) : _createCommentVNode("", true), _createElementVNode("div", {
        onClick: _cache[12] || (_cache[12] = $event => $options.clickAddChildType())
      }, _toDisplayString(_ctx._t('addChildType')), 1), $data.floatMenu.questionType.nav.length > 1 ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        disabled: _ctx.user.is_readonly,
        onClick: _cache[13] || (_cache[13] = $event => $options.clickAddChildQuestion())
      }, _toDisplayString(_ctx._t('addChildQuestion')), 9, _hoisted_23)) : _createCommentVNode("", true), $data.floatMenu.questionType.nav.length > 1 ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        disabled: _ctx.user.is_readonly,
        onClick: _cache[14] || (_cache[14] = $event => $options.clickDeleteType()),
        style: {
          "border-top": "1px dashed #000",
          "color": "#c00"
        }
      }, _toDisplayString(_ctx._t('deleteType')), 9, _hoisted_24)) : _createCommentVNode("", true)], 64))]),
      _: 1
    }, 8, ["show", "x", "y"])) : _createCommentVNode("", true)], 4), [[_vShow, !$data.fold]])]),
    _: 1
  })]), _createElementVNode("div", {
    style: _normalizeStyle([{
      "width": "100%",
      "height": "2rem",
      "background-color": "#000",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "cursor": "pointer"
    }, {
      transform: $data.fold ? 'rotate(180deg)' : ''
    }]),
    onClick: _cache[16] || (_cache[16] = $event => $options.clickFoldPanel())
  }, _hoisted_28, 4)])], 64);
}